"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
var fetchRequest_1 = require("./fetchRequest");
var UrlParam_1 = require("../helpers/UrlParam");
var Relation_1 = require("../api/Relation");
var RelationConnector = /** @class */ (function () {
    function RelationConnector(baseUrl) {
        this.baseUrl = baseUrl;
    }
    /**
     * Get a list of relations for a specific owner member
     */
    RelationConnector.prototype.getRelations = function (owner, member, date, pagination) {
        return __awaiter(this, void 0, void 0, function () {
            var params, getConfig, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        params = new URLSearchParams();
                        if (pagination) {
                            (0, UrlParam_1.appendDefaultParams)(params, pagination);
                        }
                        (0, UrlParam_1.appendParam)(params, 'owner', owner);
                        (0, UrlParam_1.appendParam)(params, 'member', member);
                        (0, UrlParam_1.appendParam)(params, 'date', date);
                        getConfig = (0, Relation_1.getRelationsUsingGET)(params);
                        return [4 /*yield*/, (0, fetchRequest_1.fetchRequestWithPagination)(getConfig, this.baseUrl)];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, response];
                }
            });
        });
    };
    RelationConnector.prototype.updateRelation = function (relation, seqNo) {
        return __awaiter(this, void 0, void 0, function () {
            var updateConfig, response, responseJson;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        updateConfig = (0, Relation_1.updateRelation)(relation, seqNo);
                        return [4 /*yield*/, (0, fetchRequest_1.fetchRequestBase)(updateConfig, this.baseUrl)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.json()];
                    case 2:
                        responseJson = _a.sent();
                        return [2 /*return*/, {
                                data: responseJson.data,
                                successful: responseJson.successful,
                                error: responseJson.errors,
                                message: responseJson.messages,
                            }];
                }
            });
        });
    };
    RelationConnector.prototype.getRelation = function (seqNo) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, (0, fetchRequest_1.fetchRequest)((0, Relation_1.getRelation)(seqNo), this.baseUrl)];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    RelationConnector.prototype.createRelation = function (relation) {
        return __awaiter(this, void 0, void 0, function () {
            var createConfig, response, responseJson;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        createConfig = (0, Relation_1.createRelation)(relation);
                        return [4 /*yield*/, (0, fetchRequest_1.fetchRequestBase)(createConfig, this.baseUrl)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.json()];
                    case 2:
                        responseJson = _a.sent();
                        return [2 /*return*/, {
                                data: responseJson.data,
                                successful: responseJson.successful,
                                error: responseJson.errors,
                                message: responseJson.messages,
                            }];
                }
            });
        });
    };
    return RelationConnector;
}());
exports.default = RelationConnector;
